"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_voice__of__vodafone__alerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "voice-of-vodafone-alerts-mid"), /*#__PURE__*/React.createElement("g", {
    id: "4343610b-9f43-4e52-8782-8dccccaf2eb8",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b96d147f-9d4b-47e6-a7ab-8bc7375eb579",
    "data-name": "Business_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    id: "7ba449ae-735c-47d8-b45b-b0490a050619",
    "data-name": "<Pfad>",
    x1: 130,
    y1: 62,
    x2: 42,
    y2: 62,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "582727b5-3df1-40ab-8266-2c09d52eab69",
    "data-name": "<Pfad>",
    x1: 130,
    y1: 86,
    x2: 42,
    y2: 86,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "a0985f13-9c7d-4ddd-a9fd-d0268cbcd7ca",
    "data-name": "<Pfad>",
    x1: 130,
    y1: 110,
    x2: 42,
    y2: 110,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,165V133H31a14,14,0,0,1-14-14V51A14,14,0,0,1,31,37H141a12,12,0,0,1,12,12v72a12,12,0,0,1-12,12H79Z",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,37V35A14,14,0,0,1,51,21H159a14,14,0,0,1,14,14v68a14,14,0,0,1-14,14h-6",
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#666",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))));
}

var _default = ic_voice__of__vodafone__alerts;
exports.default = _default;